import {SERVER_API_FB_BOT} from '../../constans/index';
import {
    LIST_TAG_REQUEST,
    LIST_TAG_SUCCESS,
    LIST_TAG_FAILURE,
} from '../../types/index';
import {RSAA} from 'redux-api-middleware';
import headers from "../../utils/headers";

const ListTagAction = () => ({

    [RSAA]: {
        endpoint: () => {
            return `${SERVER_API_FB_BOT}/api/tags`;
        },
        method: 'GET',
        headers: (headers()),
        types: [
            LIST_TAG_REQUEST,
            {
                type: LIST_TAG_SUCCESS,
                payload: async (action, state, res) => {
                    const contentType = res.headers.get('Content-Type');
                    let data = [];
                    if (contentType && ~contentType.indexOf('json')) {
                        await res.json().then((json) => {
                            data = json.data
                        });
                        return {
                            "code": 0,
                            "type": LIST_TAG_SUCCESS,
                            "data": data
                        }
                    }

                }
            },
            {
                type: LIST_TAG_FAILURE,
                payload: async (action, state, res) => {

                    let message = "";
                    await res.json().then((json) => {
                        message = json.message;
                    });

                    return {
                        "code": 1,
                        "type": LIST_TAG_FAILURE,
                        "message": message,
                        "data": [],
                    }
                }
            }
        ]
    }

});

export {ListTagAction}